module.exports = __webpack_public_path__ + "static/media/lion.8bcd2838.png";